import { useEffect, useRef, useState } from "react";

import GuestImg from "../../assets/images/conversations/ep-32-gaurav-gupta-guest.webp";
import ThumbImg from "../../assets/images/conversations/032.webp";
import PlayIcon  from "../../assets/icons/conversations/play-icon.svg";

/* ─────────────────────────────────────────────
   PREFIX: mg-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .mg-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }
  .mg-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  .mg-hero { padding-top: 60px; padding-bottom: 60px; }
  .mg-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }
  .mg-hero__left { display: flex; flex-direction: column; gap: 44px; }
  .mg-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .mg-hero__title.mg-visible { opacity: 1; transform: translateY(0); }
  .mg-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .mg-hero__spotify.mg-visible { opacity: 1; transform: translateY(0); }
  .mg-hero__spotify iframe {
    display: block; width: 100%; height: 152px; border: none; border-radius: 12px;
  }
  .mg-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .mg-hero__right.mg-visible { opacity: 1; transform: translateY(0); }

  .mg-yt-thumb {
    position: relative; width: 100%; border-radius: 12px;
    overflow: hidden; cursor: pointer; display: block; background: #000;
  }
  .mg-yt-thumb img {
    width: 100%; height: auto; display: block;
    border-radius: 12px; transition: opacity 0.3s ease;
  }
  .mg-yt-thumb:hover img { opacity: 0.85; }
  .mg-yt-thumb__play {
    position: absolute; top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    background: none; border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    pointer-events: none;
  }
  .mg-yt-thumb__play img { width: 40px; height: 44px; }
  .mg-yt-iframe-wrap {
    position: relative; width: 100%; padding-bottom: 56.25%;
    height: 0; border-radius: 12px; overflow: hidden;
  }
  .mg-yt-iframe-wrap iframe {
    position: absolute; top: 0; left: 0;
    width: 100%; height: 100%; border: none;
  }

  .mg-body {
    padding-bottom: 100px; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .mg-body.mg-visible { opacity: 1; transform: translateY(0); }
  .mg-body__para {
    font-family: 'Roboto', sans-serif; font-size: 16px;
    font-weight: 400; color: #E2E2E2; line-height: 160%; margin-bottom: 14px;
  }
  .mg-body__para:last-child { margin-bottom: 0; }

  .mg-guest {
    padding-bottom: 100px; text-align: center; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .mg-guest.mg-visible { opacity: 1; transform: translateY(0); }
  .mg-guest__title {
    font-family: 'Montserrat', sans-serif; font-size: 50px;
    font-weight: 700; color: #ffffff; margin-bottom: 60px;
  }
  .mg-guest__photo-bg {
    display: inline-block; width: 445px; height: 500px;
    background: #743FAC; border-radius: 12px; overflow: hidden;
  }
  .mg-guest__photo-bg img {
    width: 100%; height: 100%; object-fit: cover;
    object-position: top center; display: block;
  }
  .mg-guest__name {
    font-family: 'Montserrat', sans-serif; font-size: 32px;
    font-weight: 700; color: #ffffff; margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .mg-inner { padding-left: 32px; padding-right: 32px; }
    .mg-hero { padding-top: 32px; padding-bottom: 48px; }
    .mg-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .mg-hero__title { font-size: 24px; }
    .mg-hero__left { gap: 16px; }
    .mg-guest__title { font-size: 24px; margin-bottom: 24px; }
    .mg-guest__photo-bg { width: 260px; height: 300px; }
    .mg-guest__name { font-size: 24px; margin-top: 18px; }
    .mg-body__para { font-size: 14px; margin-bottom: 12px; }
    .mg-body { padding-bottom: 48px; }
    .mg-guest { padding-bottom: 48px; }
    .mg-yt-thumb__play img { width: 30px; height: 32px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .mg-inner { padding-left: 16px; padding-right: 16px; }
    .mg-hero { padding-top: 51px; padding-bottom: 30px; }
    .mg-hero__grid { grid-template-columns: 1fr; gap: 30px; }
    .mg-hero__left { gap: 30px; }
    .mg-hero__title { font-size: 30px; }
    .mg-body__para { font-size: 16px; margin-bottom: 10px; }
    .mg-guest__title { font-size: 30px; margin-bottom: 20px; }
    .mg-guest__photo-bg { width: 100%; height: 386px; }
    .mg-guest__name { font-size: 24px; text-align: left; margin-top: 14px; }
    .mg-body { padding-bottom: 30px; }
    .mg-guest { padding-bottom: 30px; }
    .mg-yt-thumb__play img { width: 30px; height: 32px; }
  }
`;

function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("mg-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

const YT_VIDEO_ID = "_h5QFcmC7Jc";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);
  if (playing) {
    return (
      <div className="mg-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 32 MG"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }
  return (
    <div className="mg-yt-thumb" onClick={() => setPlaying(true)} role="button" aria-label="Play video">
      <img src={ThumbImg} alt="EP 32 MG thumbnail" />
      <div className="mg-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

function HeroSection() {
  const titleRef   = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);
  useFadeUp(titleRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="mg-hero">
      <div className="mg-inner">
        <div className="mg-hero__grid">
          <div className="mg-hero__left">
            <h1 ref={titleRef} className="mg-hero__title">
              EP 32 | Navigating the new urban jungle: MG may have a plan
            </h1>
            <div ref={spotifyRef} className="mg-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/4yUSWJQLTquqfrnvnqv0kw?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 32 Spotify Player"
              />
            </div>
          </div>
          <div ref={rightRef} className="mg-hero__right">
            <YouTubeEmbed />
          </div>
        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="mg-body">
      <div className="mg-inner">
        <p className="mg-body__para">
          On our program, we have the opportunity, or perhaps the word is providence, to speak with some of the major protagonists and decision-makers in the electric mobility sector in India. More than ever we have enjoyed speaking with the senior team at MG Motor India, who so often bring an unfiltered and refreshing viewpoint on clean mobility. Today we welcome back to our program Gaurav GUPTA, Chief Commercial Officer of MG Motor India. His team recently commissioned a very interesting study through Nielsen in India exploring driver behavior and road use challenges as a run-up to the launch of their latest EV in India... the MG Comet. Our host Ravin MIRCHANDANI spoke with Gaurav this week where the conversation covered the findings of the Nielsen study and some teasers on the new Comet soon to be launched.
        </p>
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="mg-guest">
      <div className="mg-inner">
        <h2 className="mg-guest__title">Our Guest</h2>
        <div>
          <div className="mg-guest__photo-bg">
            <img src={GuestImg} alt="Gaurav Gupta" />
          </div>
          <p className="mg-guest__name">Gaurav Gupta</p>
        </div>
      </div>
    </section>
  );
}

export default function Ep32MG() {
  return (
    <>
      <style>{CSS}</style>
      <div className="mg-page">
        <HeroSection />
        <BodySection />
        <GuestSection />
      </div>
    </>
  );
}